export default "__VITE_ASSET__01955c6f__"